;(function () {
  'use strict'
  angular.module('contrast.tsv').controller('TsvBackupCtrl', TsvBackupCtrl)

  function TsvBackupCtrl(
    $scope,
    $location,
    UserService,
    ErrorService,
    logoutService,
    tsvApiConfig
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {}
    })

    angular.extend($scope, {
      submit: submit,
      logout: logout
    })

    function submit() {
      tsvApiConfig.authorizeScratchCode({ code: $scope.model.code }).then(
        function (_response) {
          $location.path(UserService.buildUrl('/dashboard'), true)
        },
        function (response) {
          if (response.status == 423) {
            logoutService.logout({
              redirectParams: { failedMaxAttempts: true }
            })
          } else {
            ErrorService.processError(response)
          }
        }
      )
    }

    function logout() {
      logoutService.logout({ redirectToSignin: true })
    }
  }
})()
